export const SIDE_BAR_WIDTH = 180;
